import { ref } from 'vue';

const downloadVisible = ref(false);

export const useDownloadDialog = () => {
  const openDownloadDialog = () => {
    downloadVisible.value = true;
  };

  const closeDownloadDialog = () => {
    downloadVisible.value = false;
  };

  return {
    downloadVisible,
    openDownloadDialog,
    closeDownloadDialog,
  };
};
